@if (banner) {
  <div class="app-banner-mobile-body">
    @if (banner?.url) {
      <a
        target="_blank"
        href="{{ banner?.url }}{{ utm(banner.url) }}"
        (click)="click()"
        [id]="bannerPositionId + ' | ' + banner?.url"
        class="app-banner-main text-center"
        >
        <img
          src="{{ banner?.path }}"
          alt="{{ banner?.altText }}"
          class="app-banner-mobile-body__image text-center"
                srcset="{{ banner?.small_image }} 600w,
                    {{ banner?.medium_image }} 1024w,
                    {{ banner?.large_image }} 1600w"
          />
      </a>
    } @else {
      @if (!banner?.url) {
        <img
          src="{{ banner?.path }}"
          alt="{{ banner?.altText }}"
                srcset="{{ banner?.small_image }} 600w,
                        {{ banner?.medium_image }} 1024w,
                        {{ banner?.large_image }} 1600w"
          class="app-banner-mobile-body__image"
          />
      }
    }
  </div>
}
